import axios from "axios";
import { useToast } from "vue-toastification";
import router from "../../router";

export default {
  namespaced: true,
  state: {
    placed_order_id: "",
    related_products: [],
    related_products_modal: false,
    status: {
      placeOrder: {
        loading: false,
        error: "",
      },
    },
  },
  getters: {
    ordersStatus: (state) => state.status,
    getPlacedOrderId: (state) => state.placed_order_id,
    getRelatedProducts: (state) => state.related_products,
    getRelatedProductsModal: (state) => state.related_products_modal,
  },
  actions: {
    async placeOrder({ commit }, formdData) {
      commit("setLoading", { dataName: "placeOrder", status: true });
      let token = localStorage.getItem("token");
      try {
        let { data } = await axios.post(
          process.env.VUE_APP_API_URL + "/api/frontend/place-order",
          formdData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("Order Placed", data);
        commit("setPlacedOrderId", data.payload[0].id);
        this.dispatch("cart/clearCart");
        if (formdData.payment_method == "card") {
          router.push({
            name: "Payment",
            query: { order_id: data.payload[0].id },
          });
        } else if (formdData.payment_method == "cod") {
          router.push({
            name: "Thankyou",
            query: { order_id: data.payload[0].id },
          });
        }
        commit("setLoading", {
          dataName: "placeOrder",
          status: false,
        });
      } catch (error) {
        console.log(error);
        this.dispatch("cart/fetchCart"); //refresh the cart
        commit("setLoading", {
          dataName: "placeOrder",
          status: false,
        });
        commit("setError", {
          dataName: "placeOrder",
          error: error.response,
        });
        if (error.response.data.message == "Bundled Products") {
          commit("setRelatedProducts", error.response.data.payload);
          commit("setRelatedProductsModal", true);
          useToast().error("Please select related products", { timeout: 3000 });
          return;
        }
        useToast().error(error.response.data.message, { timeout: 3000 });
      }
    },
    upateRelatedProduct({ commit }, payload) {
      commit("upateRelatedProduct", payload);
    },
    toggleModal({ commit }, status) {
      commit("setRelatedProductsModal", status);
    }
  },
  mutations: {
    upateRelatedProduct(state, payload) {
      console.log("upateRelatedProduct", payload);
      state.related_products = state.related_products.filter(product => product.id != payload);
    },
    setRelatedProductsModal: (state, payload) => {
      state.related_products_modal = payload;
    },
    setRelatedProducts: (state, payload) => {
      state.related_products = payload;
    },
    setPlacedOrderId: (state, orderId) => {
      state.placed_order_id = orderId;
    },
    setLoading: (state, { dataName, status }) => {
      state.status[dataName].loading = status;
    },
    setError: (state, { dataName, error }) => {
      state.status[dataName].error = error;
    },
  },
};
